import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./components/translation/en.json";
import th from "./components/translation/th.json";
import es from "./components/translation/es.json";
import id from "./components/translation/id.json";
import ar from "./components/translation/ar.json";
import { normalizeStoredUser } from "./utils/thaiUser";
import { getStoredLanguage } from "./utils/getLanguage";
import { applyBrandName } from "./utils/branding";

normalizeStoredUser();
const lng = getStoredLanguage();

// Rewrites the product name in every translated string so Thailand /
// healjaispace.com keep "HealJai" while all other origins read "Astria".
// Applied here so individual call sites don't each have to remember.
const brandPostProcessor = {
  type: "postProcessor" as const,
  name: "brand",
  process(value: string) {
    return applyBrandName(value);
  },
};

i18n.use(brandPostProcessor).use(initReactI18next).init({
  resources: {
    en: { translation: en },
    th: { translation: th },
    es: { translation: es },
    id: { translation: id },
    ar: { translation: ar },
  },

  lng,
  fallbackLng: ["th", "en"],

  interpolation: {
    escapeValue: false,
  },

  postProcess: ["brand"],
});

export default i18n;
